var React = require('react');

function Quote (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#CD0100","fillRule":"nonzero","d":"M30.273 0v5.496c-3.546.887-5.728 3.103-5.818 5.852 4 .177 6.545 2.66 6.545 6.648C31 22.163 27.91 25 24 25c-4.636 0-8-2.926-8-9.486C16 6.117 22.273.798 30.273 0zm-16 0v5.496c-3.546.887-5.728 3.103-5.818 5.852 4 .177 6.545 2.66 6.545 6.648C15 22.163 11.91 25 8 25c-4.636 0-8-2.926-8-9.486C0 6.117 6.273.798 14.273 0z"}));
}

Quote.defaultProps = {"width":"31","height":"25","viewBox":"0 0 31 25"};

module.exports = Quote;

Quote.default = Quote;
